import React, { Fragment, useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input } from "reactstrap";
import RequiredField, {
  FirstName,
  LastName,
  Submit,
  Cancel,
  BirthDate,
  Age,
  MobileNo,
  AadharNumber,
  Gender,
  Address,
  Department,
  Password,
  ConfirmPassword,
  Option1,
  Date,
} from "../../../Constant";
import { Breadcrumbs, Image } from "../../../AbstractElements";
import { useNavigate, useLocation } from "react-router";
import {
  CreateDoctor,
  DoctorDepartmentList,
  loginuserdata,
  StoreInquiry,
  UpdateDocor,
  UpdateDoctor,
} from "../../../apiController";
import { toast } from "react-toastify";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { Card, CardBody } from "react-bootstrap";

const InquiryForm = () => {
  const navigate = useNavigate();

  const {
    control,
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  const userId = loginuserdata.user.id;

  console.log(loginuserdata)

  const onSubmit = async (data) => {
    console.log(data);

    const formattedData = {
        "date" : data.date,
          "patient_id" : userId,
            "enquiry": data.reason
   }

   try{
    const response = await StoreInquiry(formattedData);
   
        if (response.status === true) {
                          toast.success('Inquiry Sent Successfully!', { position: toast.POSITION.TOP_CENTER });
                      }
    
   }catch(error){
    toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
   }finally{
    reset()
   }
  };

  return (
    <Fragment>
      <Breadcrumbs
        parent="Patient"
        mainTitle="Inquiry Form"
        title="Inquiry Form"
      />
      <Card className="login-main">
      <CardBody>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="theme-form login-form needs-validation"
        >
          <FormGroup className="mb-3">
            <Label htmlFor="reason">
              {"Reason"} <RequiredField />
            </Label>
            <input
              className={`form-control ${errors.reason && "is-invalid"}`}
              id="reason"
              type="text"
              name="reason"
              {...register("reason", { required: true })}
            />
            <span className="text-danger">
              {errors.reason && "Reason is required"}
            </span>
          </FormGroup>

          <FormGroup className="mb-3">
            <Label htmlFor="Bdate">
              {Date} <RequiredField />
            </Label>
            <Controller
              control={control}
              name="date"
              render={({ field }) => (
                <input
                  {...field}
                  className={`form-control ${errors.date && "is-invalid"}`}
                  id="date"
                  type="date"
                />
              )}
            />
            <span className="text-danger">
              {errors.birthday && "Date is required"}
            </span>
          </FormGroup>

          <div className="text-end btn-mb mt-5">
                <Button className="primary" type="submit">
                  {Submit}
                </Button>
              </div>
        </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default InquiryForm;
